import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../../shared-zorro.module';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-sider',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './sider.component.html',
  styleUrl: './sider.component.less',
})
export class SiderComponent {}
